import { ITermsDurations } from '../../../actions/publishTerms';
import { IPromotionDuration } from '../../../repositories/billing-tariffs/entities/PublishTerms/PromotionDuration';
import { defaultTo } from 'lodash';

export const mapTermsDurations = (termsDurations: IPromotionDuration[] | undefined): ITermsDurations => {
  return {
    durations: defaultTo(termsDurations, []),
    durationInDays: termsDurations?.find(term => term.isSelected)?.durationInDays || 1,
  };
};
